function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { PureComponent } from "react";
import { componentStyles } from "./generic-form-input.scss";
import { withGenericConfig } from "/contexts/generic-config-context";
import classnames from "classnames";
import { getInputComponentByType } from "client/services/form-service/form-inputs";
class GenericFormInput extends PureComponent {
    render() {
        const { inputData, errorState, translate, isV2 } = this.props;
        const { isRequired, title, style, type, id, defaultValue, placeholder } = inputData;
        const { isValid, errorMessage } = errorState;
        const requiredTextLabel = translate(errorMessage);
        const InputComponent = getInputComponentByType(type);
        const errorLabelId = `error_${id}`;
        return /*#__PURE__*/ _jsxs("div", {
            style: _object_spread({}, style),
            className: `jsx-${componentStyles.__hash}` + " " + "generic-form-input-component",
            children: [
                !isV2 && /*#__PURE__*/ _jsx("label", {
                    htmlFor: id,
                    className: `jsx-${componentStyles.__hash}` + " " + (classnames("input-title", {
                        "contact-form-required-input": isRequired
                    }) || ""),
                    children: translate(title)
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: `jsx-${componentStyles.__hash}` + " " + "form-input-wrapper",
                    children: [
                        /*#__PURE__*/ _jsx(InputComponent, _object_spread_props(_object_spread({
                            id: id
                        }, this.props), {
                            isRequired: isRequired,
                            invalid: !isValid,
                            errorLabelId: isValid ? null : errorLabelId,
                            defaultValue: defaultValue,
                            placeholder: isV2 ? translate(placeholder) : placeholder,
                            className: `jsx-${componentStyles.__hash}` + " " + (this.props && this.props.className != null && this.props.className || "")
                        })),
                        !isValid && !isV2 && /*#__PURE__*/ _jsx("span", {
                            id: errorLabelId,
                            className: `jsx-${componentStyles.__hash}` + " " + "required-error",
                            children: requiredTextLabel
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: componentStyles.__hash,
                    children: componentStyles
                })
            ]
        });
    }
    constructor(props){
        super(props);
    }
}
GenericFormInput.defaultProps = {
    errorState: {
        isValid: true,
        errorMessage: null
    }
};
export default withGenericConfig(GenericFormInput);
